import React, { useState, useEffect } from "react";
import {
  Box,
  Flex,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";
import Card from "components/card/Card.js";
import BarChart from "components/charts/BarChart";
import axios from 'axios';
import { barChartDataConsumption } from "variables/charts";

export default function CVE(props) {
  const { ...rest } = props;

  const textColor = useColorModeValue("secondaryGray.900", "white");

  const [hosts, setHosts] = useState([]);
  const [cveCountsByHost, setCveCountsByHost] = useState([]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const uri = process.env.REACT_APP_AWS_FLASK_BASE_URI + "/cves_by_host";
    const data = {
      "api_key": process.env.REACT_APP_AWS_FLASK_API_KEY
    };
    axios.post(uri, data)
      .then(response => {
        console.log(response.data);
        const hostsData = response.data.map(item => item._id);
        const cveCountsData = response.data.map(item => item.cve_count);
        // const hostsData = response.data.hosts || [];
        // const cveCountsData = response.data.cveCountsByHost || [];

        console.log("Fetched CVE hosts: ", hostsData);
        console.log("Fetched CVE counts by host: ", cveCountsData);
        console.log("Test data", barChartDataConsumption);

        // setHosts(hostsData);
        // setCveCountsByHost(cveCountsData);
        setHosts(hostsData);
        setCveCountsByHost(cveCountsData);
        setLoading(false);
      })
      .catch(error => {
        console.error("There was an error fetching the CVE data!", error);
        setError(error);
        setLoading(false);
      });
  }, []);

  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error loading data: {error.message}</p>;

  const barChartDataCveCountByHost = [
    {
      name: "Hosts with Highest Number of CVEs",
      data: cveCountsByHost // Use the state directly
    }
  ];

  const barChartOptionsCveCountByHost = {
    chart: {
      toolbar: {
        show: true,
      },
    },
    tooltip: {
      style: {
        fontSize: "12px",
        fontFamily: undefined,
      },
      onDatasetHover: {
        style: {
          fontSize: "12px",
          fontFamily: undefined,
        },
      },
      theme: "dark",
    },
    xaxis: {
      categories: hosts,
      show: false,
      labels: {
        show: true,
        style: {
          colors: "#A3AED0",
          fontSize: "14px",
          fontWeight: "500",
        },
      },
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
    },
    yaxis: {
      show: false,
      color: "black",
      labels: {
        show: true,
        style: {
          colors: "#CBD5E0",
          fontSize: "14px",
        },
      },
    },
    grid: {
      show: false,
      strokeDashArray: 5,
      yaxis: {
        lines: {
          show: true,
        },
      },
      xaxis: {
        lines: {
          show: false,
        },
      },
    },
    fill: {
      type: "gradient",
      gradient: {
        type: "vertical",
        shadeIntensity: 1,
        opacityFrom: 0.7,
        opacityTo: 0.9,
        colorStops: [
          [
            {
              offset: 0,
              color: "#4318FF",
              opacity: 1,
            },
            {
              offset: 100,
              color: "rgba(67, 24, 255, 1)",
              opacity: 0.28,
            },
          ],
        ],
      },
    },
    dataLabels: {
      enabled: false,
    },
    plotOptions: {
      bar: {
        borderRadius: 10,
        columnWidth: "40px",
      },
    },
  };

  return (
    <Card align='center' direction='column' w='100%' {...rest}>
      <Flex align='center' w='100%' px='15px' py='10px'>
        <Text
          me='auto'
          color={textColor}
          fontSize='xl'
          fontWeight='700'
          lineHeight='100%'>
          {barChartDataCveCountByHost[0].name}
        </Text>
      </Flex>

      <Box h='240px' mt='auto'>
        {hosts.length > 0 && cveCountsByHost.length > 0 ? (
          <BarChart
            chartData={barChartDataCveCountByHost}
            chartOptions={barChartOptionsCveCountByHost}
          />
        ) : (
          <Text
            me='auto'
            color={textColor}
            fontSize='xl'
            fontWeight='700'
            lineHeight='100%'>
            No data available
          </Text>
        )}
      </Box>
    </Card>
  );
}
